import React, { useEffect, useState } from 'react'
import Header from "../template/Header";
import Menu from "../template/Menu";
import Footer from "../template/Footer";
import Loading from "../components/loading/Loading";
import { Col, Row } from "react-bootstrap";
import {
    textSearchBtn,
    textResetBtn,
    textCreateBtn,
    colorSearchBtn,
    colorResetBtn,
    colorCreateBtn,
    iconSearchBtn,
    iconResetBtn,
    iconCreateBtn,
    hoverSearchBtn,
    hoverResetBtn,
    hoverCreateBtn,
    textSaveBtn,
    textCancleBtn,
    colorSaveBtn,
    colorCancleBtn,
    hoverSaveBtn,
    hoverCancleBtn,
    colorEditBtns,
    hoverEditBtns
} from "../components/ThemeConfig/btnConfig";
import { useButtonDynamicStyles } from "../components/useDynamic/Button_DynamicStyle";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { createAndUpdateBusRetail,getBusRetail } from '../api/business_api'
import UploadIMG from "../components/uploads/UploadIMG";
import {
    alertValidateData,
    alertConfirmSave,
    alertSaved,
    alertCancel,
} from "../components/alertValid/AlertValid.js"
import CustomCKEditor from '../components/ckEditor/CustomCKEditor.js';

function RetailCenterDetail() {
    useButtonDynamicStyles(
        textSearchBtn,
        textResetBtn,
        textCreateBtn,
        colorSearchBtn,
        colorResetBtn,
        colorCreateBtn,
        iconSearchBtn,
        iconResetBtn,
        iconCreateBtn,
        hoverSearchBtn,
        hoverResetBtn,
        hoverCreateBtn,
        textSaveBtn,
        textCancleBtn,
        colorSaveBtn,
        colorCancleBtn,
        hoverSaveBtn,
        hoverCancleBtn,
        colorEditBtns,
        hoverEditBtns
    );
    
    const [isLoading, setLoading] = useState(false);

    const [txtEnDesc, setTxtEnDesc] = useState('');
    const [txtThDesc, setTxtThDesc] = useState('');
    const [txtEnDesc1, setTxtEnDesc1] = useState('');
    const [txtThDesc1, setTxtThDesc1] = useState('');
    const [txtEnDesc2, setTxtEnDesc2] = useState('');
    const [txtThDesc2, setTxtThDesc2] = useState('');
    const [txtEnDesc3, setTxtEnDesc3] = useState('');
    const [txtThDesc3, setTxtThDesc3] = useState('');
    const [images1, setImages1] = useState([]);
    const [imagesFromApi1, setImagesFromApi1] = useState([]);
    const [images2, setImages2] = useState([]);
    const [imagesFromApi2, setImagesFromApi2] = useState([]);
    const [images3, setImages3] = useState([]);
    const [imagesFromApi3, setImagesFromApi3] = useState([]);
    const [images4, setImages4] = useState([]);
    const [imagesFromApi4, setImagesFromApi4] = useState([]);

    const [dataContact, setDataContact] = useState({
        toContact: null,
        ccContact: null,
        linkVR: null,
    });

    const handleSelectedImages1 = (images) => {
        setImages1(images);
    };
    const handleSelectedRemoveImg1 = (data) => {
        setImages1(data);
    };

    const handleSelectedImages2 = (images) => {
        setImages2(images);
    };
    const handleSelectedRemoveImg2 = (data) => {
        setImages2(data);
    };

    
    const handleSelectedImages3 = (images) => {
        setImages3(images);
    };
    const handleSelectedRemoveImg3 = (data) => {
        setImages3(data);
    };

    const handleSelectedImages4 = (images) => {
        setImages4(images);
    };
    const handleSelectedRemoveImg4 = (data) => {
        setImages4(data);
    };

    const dataFloor = [
        {
            txtTitle: "Event Space For Rent",
            label1: "G Floor",
            id1: "g_floor_en",
            id2: "g_floor_th",
            id3: "g_floor_img",
            value1: txtEnDesc1,
            value2: txtThDesc1,
            placeholder1: "Description",
            placeholder2: "คำอธิบาย",
            onChange1: (event) => setTxtEnDesc1(event.target.value),
            onChange2: (event) => setTxtThDesc1(event.target.value),
            onSelectedImages: (images) => handleSelectedImages2(images),
            images: imagesFromApi2,
            removeImg: (data) => handleSelectedRemoveImg2(data)
        },
        {
            txtTitle: "Event Space For Rent",
            label1: "2nd Floor",
            id1: "2nd_floor_en",
            id2: "2nd_floor_th",
            id3: "2nd_floor_img",
            value1: txtEnDesc2,
            value2: txtThDesc2,
            placeholder1: "Description",
            placeholder2: "คำอธิบาย",
            onChange1: (event) => setTxtEnDesc2(event.target.value),
            onChange2: (event) => setTxtThDesc2(event.target.value),
            onSelectedImages: (images) => handleSelectedImages3(images),
            images: imagesFromApi3,
            removeImg: () => handleSelectedRemoveImg3()
        },
        {
            txtTitle: "Event Space For Rent",
            label1: "Leaflet Point",
            id1: "leaflet_floor_en",
            id2: "leaflet_floor_th",
            id3: "leaflet_floor_img",
            value1: txtEnDesc3,
            value2: txtThDesc3,
            placeholder1: "Description",
            placeholder2: "คำอธิบาย",
            onChange1: (event) => setTxtEnDesc3(event.target.value),
            onChange2: (event) => setTxtThDesc3(event.target.value),
            onSelectedImages: (images) => handleSelectedImages4(images),
            images: imagesFromApi4,
            removeImg: () => handleSelectedRemoveImg4()
        }
        // Add more items as needed
    ];

    const validateEmail = (email) => {
        // Regular expression for email validation
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailRegex.test(email);
    };

    const alertValidate = async () => {
        const result = await alertValidateData();
            if (result.isConfirmed) {
                return;
            } else {
                return;
            }
    }

    const handleSaveBtn = async () => {
        try {
            const emailFields = [
                { field: 'email_contact', value: dataContact.toContact },
                { field: 'email_cc', value: dataContact.ccContact },
            ];
    
            // Validate required email fields
            const invalidEmailFields = emailFields.filter(field => field.value && !validateEmail(field.value));
            
            if (invalidEmailFields.length === 0) {
                const formatedBodyToServer = {
                    vr_link: dataContact.linkVR,
                    description_en: txtEnDesc,
                    description_th: txtThDesc,
                    leaflet_en: txtEnDesc3,
                    leaflet_th: txtThDesc3,
                    event_space_floor_g_description_en: txtEnDesc1,
                    event_space_floor_g_description_th: txtThDesc1,
                    event_space_f2_description_en: txtEnDesc2,
                    event_space_f2_description_th: txtThDesc2,
                    email_contact: dataContact.toContact,
                    email_cc: dataContact.ccContact,
                    gallery: images1 ?? null,
                    imgs_fg: images2 ?? null,
                    imgs_f2: images3 ?? null,
                    imgs_f_leaflet: images4 ?? null,
                }
                if (
                    // !formatedBodyToServer.vr_link ||
                    !formatedBodyToServer.description_en ||
                    !formatedBodyToServer.description_th ||
                    !formatedBodyToServer.leaflet_en ||
                    !formatedBodyToServer.leaflet_th ||
                    !formatedBodyToServer.event_space_floor_g_description_en ||
                    !formatedBodyToServer.event_space_floor_g_description_th ||
                    !formatedBodyToServer.event_space_f2_description_en ||
                    !formatedBodyToServer.event_space_f2_description_th ||
                    !formatedBodyToServer.gallery.length > 0 ||
                    !formatedBodyToServer.imgs_fg.length > 0 ||
                    !formatedBodyToServer.imgs_f2.length > 0 ||
                    !formatedBodyToServer.imgs_f_leaflet.length > 0
                ) {
                  await alertValidate();
                } else {
                    const result = await alertConfirmSave();
                        if (result.isConfirmed) {
                          (async () => {
                            await setLoading(true);
                            const response = await createAndUpdateBusRetail('',formatedBodyToServer);
                            setLoading(false)
                            if (response.status == "success"||response.status == 200) {
                                const result = await alertSaved();
                                  if (result.isConfirmed) {
                                    window.location.reload();
                                  }
                              }
                          })();
                        }
                }
            } else {
                alertValidate();
            }
        } catch (error) {
            console.log('found error ', error)
        }
    };

    const handleClickCancel = async () => {
        const res = await alertCancel();
                if (res.isConfirmed) {
                    window.location.reload();
                }
                else { }
    };

    async function urlToBlob(url) {
        // Fetch the image data from the URL
        const response = await fetch(url);
    
        // Convert the fetched image data to Blob
        const blob = await response.blob();
    
        return blob;
    }

    const fetchingData = async () => {
        try {
            await setLoading(true);
            const response = await getBusRetail()

            await setDataContact({
                ...dataContact,
                toContact: response?.data?.data?.email_contact,
                ccContact: response?.data?.data?.email_cc,
                linkVR: response?.data?.data?.vr_gallery,
            })

            if (response?.data?.data?.description_en) {
                setTxtEnDesc(response?.data?.data?.description_en)
            }
            if (response?.data?.data?.description_en) {
                setTxtThDesc(response?.data?.data?.description_th)
            }
            if (response?.data?.data?.event_space_floor_g_description_en) {
                setTxtEnDesc1(response?.data?.data?.event_space_floor_g_description_en)
            }
            if (response?.data?.data?.event_space_floor_g_description_th) {
                setTxtThDesc1(response?.data?.data?.event_space_floor_g_description_th)
            }
            if (response?.data?.data?.event_space_f2_description_en) {
                setTxtEnDesc2(response?.data?.data?.event_space_f2_description_en)
            }
            if (response?.data?.data?.event_space_f2_description_th) {
                setTxtThDesc2(response?.data?.data?.event_space_f2_description_th)
            }
            if (response?.data?.data?.event_space_f_leaflet_description_en) {
                setTxtEnDesc3(response?.data?.data?.event_space_f_leaflet_description_en)
            }
            if (response?.data?.data?.event_space_f_leaflet_description_th) {
                setTxtThDesc3(response?.data?.data?.event_space_f_leaflet_description_th)
            }
            const gallery = response?.data?.data?.gallery;
            if (gallery && Array.isArray(gallery)) {
                const images = await Promise.all(gallery.map(async (imageSrc, index) => {
                    return {
                        id: index,
                        status: false,
                        src: imageSrc || '',
                        file: imageSrc ? await urlToBlob(imageSrc) : null,
                        size: 1024 * 1024 * 4, // hard-coded to pass validation
                        type: 'image/jpg' // hard-coded to pass validation
                    };
                }));
                setImagesFromApi1(images);
            }
            const imgs_fg = response?.data?.data?.imgs_fg;
            if (imgs_fg && Array.isArray(imgs_fg)) {
                const images = await Promise.all(imgs_fg.map(async (imageSrc, index) => {
                    return {
                        id: index,
                        status: false,
                        src: imageSrc || '',
                        file: imageSrc ? await urlToBlob(imageSrc) : null,
                        size: 1024 * 1024 * 4, // hard-coded to pass validation
                        type: 'image/jpg' // hard-coded to pass validation
                    };
                }));
                setImagesFromApi2(images);
            }
            const imgs_f2 = response?.data?.data?.imgs_f2;
            if (imgs_f2 && Array.isArray(imgs_f2)) {
                const images = await Promise.all(imgs_f2.map(async (imageSrc, index) => {
                    return {
                        id: index,
                        status: false,
                        src: imageSrc || '',
                        file: imageSrc ? await urlToBlob(imageSrc) : null,
                        size: 1024 * 1024 * 4, // hard-coded to pass validation
                        type: 'image/jpg' // hard-coded to pass validation
                    };
                }));
                setImagesFromApi3(images);
            }
            const imgs_f_leaflet = response?.data?.data?.imgs_f_leaflet;
            if (imgs_f_leaflet && Array.isArray(imgs_f_leaflet)) {
                const images = await Promise.all(imgs_f_leaflet.map(async (imageSrc, index) => {
                    return {
                        id: index,
                        status: false,
                        src: imageSrc || '',
                        file: imageSrc ? await urlToBlob(imageSrc) : null,
                        size: 1024 * 1024 * 4, // hard-coded to pass validation
                        type: 'image/jpg' // hard-coded to pass validation
                    };
                }));
                setImagesFromApi4(images);
            }
        } catch (error) {
            console.log('error', error);
        }
        await setLoading(false);
    }

    useEffect(() => {
        fetchingData()
    }, [])

  return (
    <>
        <style>
            {`
                .upload {
                    display: flex;
                    flex-direction: column; /* Stack items vertically by default */
                    position: relative;
                }
                .thumbsContainer {
                    display: flex; /* Change to flex to align children horizontally */
                    flex-wrap: wrap; /* Allow wrapping to the next line if needed */
                    width: 100%;
                    margin-top: 0;
                }
                .thumb, .boxthumb {
                    display: inline-flex;
                    border-radius: 0;
                    margin: 0 5px 10px 0; /* Margin to space items horizontally and vertically */
                    width: 100px; /* Adjust the width to fit your design */
                    height: 70px;
                    box-sizing: border-box;
                    position: relative;
                    margin-top: 1rem;
                }
                .ck.ck-editor__main>.ck-editor__editable:not(.ck-focused) {
                    height: 200px;
                }
                @media only screen and (max-width: 767px) {
                    .thumb, .boxthumb {
                        margin-left: 0;
                        margin-right: 15px;
                    }
                    .remark-dt {
                        margin-top: -25px;
                    }
                }
            `}
        </style>
        {isLoading ? <Loading /> : ""}
        <Header parentmenu={"BUSINESS"} />
        <Menu
            parentmenu={"infoBusiness"}
            activemenu={"infoRetailCenterDetail"}
        />
        <div className="content-wrapper">
            <div className="container-fluid pdb-page">
                <div className="box-white">
                    <Row>
                        <Col xs={12}>
                        
                            <font className="font-size07 colorBlack01 fontBold d-flex align-items-center">
                                <img src="assets/icons/ic-business.png" className="ic-user01 me-2" alt="" />
                                BUSINESS<FontAwesomeIcon icon={faChevronRight} className="h-8 p-2" />  RETAIL CENTER<FontAwesomeIcon icon={faChevronRight} className="h-8 p-2" /> RETAIL CENTER DETAIL
                            </font>
                        </Col>
                    </Row>
                    <div className='mx-5 mt-4'>
                        <Row>
                            <Col xs={12}>
                                <font className="font-size01 colorBlack01 fontBold">
                                Retail Center <span className=' colorRed'>*</span>
                                </font>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={6}>
                                <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                    English
                                </font>
                            </Col>
                            <Col xs={6}>
                                <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                    ภาษาไทย
                                </font>
                            </Col>
                        </Row>
                        <Row className='mt-2'>
                            <Col xs={6}>
                                <CustomCKEditor
                                    data={txtEnDesc}
                                    onChange={(newData) => {
                                        setTxtEnDesc(newData);
                                    }}
                                    placeholder="Description"
                                />
                            </Col>
                            <Col xs={6}>
                                <CustomCKEditor
                                    data={txtThDesc}
                                    onChange={(newData) => {
                                        setTxtThDesc(newData);
                                    }}
                                    placeholder="คำอธิบาย"
                                />
                            </Col>
                        </Row>
                        <Row className='mt-3'>
                            <Col xs={12}>
                                <font className="font-size01 colorBlack01 fontBold">
                                    Email Contact
                                </font>
                            </Col>
                        </Row>
                        <Row className='mt-2'>
                            <Col xs={6}>
                                <Row className='align-items-center'>
                                    <Col xs={1}><span className='fontReg font-size03 colorBlack01'>To.</span></Col>
                                    <Col xs={10} className='pe-1'>
                                        <input
                                            type="text"
                                            className="inp01 fontLight font-size03"
                                            id="to_contact"
                                            placeholder="Email Contact"
                                            value={dataContact.toContact}
                                            onChange={(event) => setDataContact({ ...dataContact, toContact: event.target.value })}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={6}>
                                <Row className='align-items-center'>
                                    <Col xs={1}><span className='fontReg font-size03 colorBlack01'>Cc.</span></Col>
                                    <Col xs={10} className='pe-1'>
                                        <input
                                            type="text"
                                            className="inp01 fontLight font-size03"
                                            id="cc_contact"
                                            placeholder="Email Contact"
                                            value={dataContact.ccContact}
                                            onChange={(event) => setDataContact({ ...dataContact, ccContact: event.target.value })}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </div>
                </div>
                <div className="box-white mt-4">
                    <div className='mx-5 mt-4'>
                        <Row>
                            <Col xs={12}>
                                <font className="font-size01 colorBlack01 fontBold">
                                    Plan / Image <span className=' colorRed'>*</span>
                                </font>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <UploadIMG
                                    limit={5}
                                    onSelectedImages={handleSelectedImages1}
                                    images={imagesFromApi1}
                                    txtDetail={"jpg. / 800x450 px , limit size 5MB"}
                                    removeImg={handleSelectedRemoveImg1}
                                />
                            </Col>
                        </Row>
                    </div>
                </div>
                <div className="box-white mt-4">
                    <div className='mx-5 mt-4'>
                        <Row>
                            <Col xs={12}>
                                <font className="font-size01 colorBlack01 fontBold">
                                    360 Virtual
                                </font>
                            </Col>
                        </Row>
                        <Row className="mt-2">
                            <Col xs={6} className='pe-1'>
                                <input
                                    type="text"
                                    className="inp01 fontLight font-size03"
                                    id="linkVR"
                                    placeholder="Enter Link 360"
                                    value={dataContact.linkVR}
                                    onChange={(event) =>
                                        setDataContact({
                                            ...dataContact,
                                            linkVR: event.target.value,
                                        })
                                    }
                                />
                            </Col>
                        </Row>
                    </div>
                </div>
                <div className="box-white mt-4">
                    {dataFloor.map((floor, index) => (
                        <div key={index} className='mx-5 mt-4'>
                            <div className="map-data">
                                <Row>
                                <Col xs={12}>
                                    <font className="font-size01 colorBlack01 fontBold">
                                    {floor.txtTitle} <span className='colorRed'>*</span>
                                    </font>
                                </Col>
                                </Row>
                                <Row>
                                <Col xs={12}>
                                    <font className="font-size01 colorBlack01 fontBold">
                                    {floor.label1}
                                    </font>
                                </Col>
                                </Row>
                                <Row>
                                <Col xs={6}>
                                    <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                    English
                                    </font>
                                </Col>
                                <Col xs={6}>
                                    <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                    ภาษาไทย
                                    </font>
                                </Col>
                                </Row>
                                <Row className='mt-2'>
                                <Col xs={6}>
                                    <CustomCKEditor
                                        data={floor.value1}
                                        onChange={(newData) => {
                                            if (floor.id1 === "g_floor_en") setTxtEnDesc1(newData);
                                            else if (floor.id1 === "2nd_floor_en") setTxtEnDesc2(newData);
                                            else if (floor.id1 === "leaflet_floor_en") setTxtEnDesc3(newData);
                                        }}
                                        placeholder={floor.placeholder1}
                                    />
                                </Col>
                                <Col xs={6}>
                                    <CustomCKEditor
                                        data={floor.value2}
                                        onChange={(newData) => {
                                            if (floor.id2 === "g_floor_th") setTxtThDesc1(newData);
                                            else if (floor.id2 === "2nd_floor_th") setTxtThDesc2(newData);
                                            else if (floor.id2 === "leaflet_floor_th") setTxtThDesc3(newData);
                                        }}
                                        placeholder={floor.placeholder2}
                                    />
                                </Col>
                                </Row>
                                <Row>
                                <Col xs={12} className="mt-2">
                                    <font className="font-size01 colorBlack01 fontBold">
                                    Image <span className='colorRed'>*</span>
                                    </font>
                                </Col>
                                </Row>
                                <Row>
                                <Col xs={12}>
                                    <UploadIMG
                                        limit={5}
                                        id={floor.id3}
                                        onSelectedImages={floor.onSelectedImages}
                                        images={floor.images}
                                        imagesFromApi={floor.imagesFromApi}
                                        txtDetail={"jpg. / 800x400 px , limit size 5MB"}
                                        removeImg={floor.removeImg}
                                    />
                                </Col>
                                </Row>
                            </div>
                        </div>
                    ))}
                </div>
                <Row className="ms-5 mt-4">
                    <Col xs={1} className="p-0 d-flex justify-content-start me-4">
                        <button
                            className="btn-cancle01"
                            onClick={() => handleClickCancel()}
                        >
                            CANCEL
                        </button>
                    </Col>
                    <Col xs={1} className="p-0 d-flex justify-content-start">
                        <button
                            className="btn-save01"
                            onClick={(e) => {
                                handleSaveBtn();
                            }}
                        >
                            SAVE
                        </button>
                    </Col>
                </Row>
            </div>
        </div>
        <Footer/>
    </>
  )
}

export default RetailCenterDetail;